const setRole = async ({commit} , obj) => {
  await axios.post(`${process.env.API_PATH}/role` , obj)
}

const setList = async ( {commit} , obj ) => {
    const list = (await axios.get(`${process.env.API_PATH}/role`)).data
    commit('SET_LIST',{list})
}

export default {
  setRole,
  setList
}



// WEBPACK FOOTER //
// ./src/features/Role/store/actions.js